module.exports = __webpack_public_path__ + "static/page-title-c299148db2b925708907b36156b7bace.png";